import React, { useEffect } from 'react';
import { Alert, Button } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Text, Row, Container } from 'styles';
import { ErrorPage } from 'components/errors';
import { LoadingPage } from 'components/loading';
import { trackEvent } from 'domain/tracking';
import { selectedUtilityAccountDisplayName } from '../select-utility-account';
import { MovingDetail } from './moving-detail.component';
import { PreviousAddressBackDrop } from './review-new-home.style';
import { MovingAddress } from './moving-address.component';
import { commonMovingPayload } from '../../state-machine/actions';

const getCopy = copyFor('settings.moving.reviewNewHome');

interface Props {
  context: MovingStateMachineContext;
  matches: (state: string) => boolean;
  next: (...args: any[]) => any;
}

export const ReviewNewHome = ({ matches, next, context }: Props) => {
  const { utility: selectedUtility, zipCode, nickname } = context;

  useEffect(() => {
    trackEvent('moving_review_new_home', {
      metadata: commonMovingPayload(context),
    });
  }, []);

  if (matches('reviewNewHome.newPlanAmountCentsErrored')) {
    return <ErrorPage title={getCopy('title')} />;
  } else if (matches('reviewNewHome.loadNewPlanAmountCents')) {
    return <LoadingPage />;
  }

  let createPlanError;
  if (matches('reviewNewHome.newPlanAmountCentsLoaded.createPlanError'))
    createPlanError = getCopy('createPlanError');

  const { displayName: newUtilityName } = selectedUtility;

  const name = selectedUtilityAccountDisplayName(context);
  const buttonLoading = matches(
    'reviewNewHome.newPlanAmountCentsLoaded.invokeCreatePlan'
  );

  return (
    <>
      <Text
        tag="h1"
        textStyle="heading800"
        margin={{ bottom: '16px', top: '33px' }}
      >
        {getCopy('title')}
      </Text>
      <Text>{getCopy('description')}</Text>
      <Container margin={{ top: '40px' }}>
        <PreviousAddressBackDrop>
          <MovingAddress
            title={getCopy('previousAddress')}
            label={getCopy('homeAddress')}
            text={name}
          />
        </PreviousAddressBackDrop>
        <Row margin={{ top: '24px' }}>
          <MovingAddress
            title={getCopy('updatedInfo')}
            label={getCopy('zipCode')}
            text={zipCode}
          />
        </Row>
        <Container direction="column" margin={{ top: '24px', bottom: '0px' }}>
          <MovingDetail label={getCopy('utility')} text={newUtilityName} />
          {nickname && (
            <MovingDetail label={getCopy('newNickname')} text={nickname} />
          )}
        </Container>
      </Container>
      <Alert margin={{ bottom: '16px' }}>{createPlanError}</Alert>
      <Button
        fullWidth
        onClick={() => {
          next();
        }}
        loading={buttonLoading}
      >
        {getCopy('nextButton')}
      </Button>
    </>
  );
};
